import { useContext } from 'react';
import { GalleryContext, GalleryContextType } from '#advertDetail/components/gallery';

const useGalleryContext = () => useContext<GalleryContextType>(GalleryContext);

export { useGalleryContext };
